import type { AgentInstallCommand } from './types.js';
import { runNpmGlobalInstall } from './run-npm-global-install.js';

export const opencodeInstallCommand: AgentInstallCommand = {
  agentType: 'opencode',
  detectCommand: 'opencode',
  async install(ctx) {
    const logOutput = await runNpmGlobalInstall('opencode-ai', {
      ...ctx.env,
      OPENCODE_API_KEY: ctx.authToken,
    });
    ctx.onProgress?.('Installing OpenCode', logOutput || undefined);
  },
};
